<style lang="less" scoped>
.flfwlist{display: flex;flex-direction: column;width: 1200px; margin: 20px auto;}
.title{width: 980px;}
.fujian:hover{cursor: pointer;color:rgb(45, 137, 241);}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;margin-bottom: 40px;}
.btnbox .btn {margin-top: 10px;margin-left: 15px;}
.recycling_box .delete {margin-left: 40px;}
.btnbox .level {margin-left: 10px;}
.el-pagination {text-align: center;}
.pagination{margin: 20px auto;}
</style>

<template>
  <div class="flfwlist" id="flfwlist">
    <div class="el-tablebox">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%; font-size: 15px;"
        @selection-change="handleSelectionChange"
        stripe
        border
        :cell-style="{textAlign: 'center', padding: '0'}"
        :header-cell-style="{background: '#ECF6FF', color: '#606266', textAlign: 'center',}">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="index" label="序号" width="80"> </el-table-column>
        <el-table-column prop="content" label="咨询内容"> </el-table-column>
        <el-table-column label="相关图片" width="160">
          <template slot-scope="scope">
            <p class="fujian" @click="look(scope.row.thumb)">查看附件</p>
            <el-dialog :visible.sync="isdialogVisible" width="30%" title="相关图片" class="mydialog">
              <img :src="urlShow" width="320px" height="280px" class="head_pic"/>
            </el-dialog>
          </template>
        </el-table-column>
        <el-table-column label="提问时间" width="200">
          <template slot-scope="scope">{{ (scope.row.addtime * 1000) | formatTime() }}</template>
        </el-table-column>
        <el-table-column prop="id" label="操作" width="160">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="select(scope.row)">查看回复</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="countSum">
      </el-pagination>
    </div>
    <el-button type="success" @click="question()" style="margin: 10px auto;width: 120px;">我要咨询</el-button>
  </div>
</template>

<script>
/**
 * 何宽
 * 法律服务列表页面
 */
import filters from '../method/filter'
export default {
  mixins: [filters],
  data()
  {
    return {
      count: 20,
      pageSize: 20,
      currentPage: 1,
      countSum: null,
      urlShow: '',
      isdialogVisible: false,
      //列表数据
      tableData: []
    }
  },
  created()
  {
    this.getList()
  },
  methods: {
    //咨询
    question()
    {
      if (localStorage.getItem('username') === '')
        this.$message({message: '请先注册登录后到会员中心进行咨询', type: 'error', customClass: 'mzindex'})
      else
      {
        let url = this.$router.resolve({path: '/Members'})
        window.open(url.href, '_blank')
      }
    },
    //获取数据
    getList()
    {
      let count = this.count
      let currentPage = this.currentPage
      let paras = {cmd: 'query', _major: 11, _minor: 63, _exp: 'id>0 and type=2', init: 0, pageno: `${currentPage}`, pagesize: `${count}`, orderby: 'addtime DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.countSum = ret[0].total
        this.tableData = []
        ret[0].data.forEach((item, index) =>
        {
          this.tableData.push({
            id: item.id,
            index: index + 1,
            content: item.content,
            thumb: item.thumb ? item.thumb : 'static/images/moren.jpg',
            addtime: item.addtime
          })
        })
      })
    },
    // 查看附件
    look(str)
    {
      this.urlShow = str
      this.isdialogVisible = true
    },
    //点击查看
    select(row)
    {
      let url = this.$router.resolve({path: '/FlfwPL', query: {id: row.id}})
      window.open(url.href, '_blank')
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    },
    search()
    {
      this.getList()
      this.handleSizeChange(this.count)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/project/FlfwList.vue